export function addDaysIso(iso: string, days: number): string {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

function easterSunday(year: number): string {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(year, month - 1, day)).toISOString().slice(0, 10);
}

const holidayCache = new Map<number, Set<string>>();

export function norwegianHolidays(year: number): Set<string> {
  const cached = holidayCache.get(year);
  if (cached) return cached;
  const easter = easterSunday(year);
  const set = new Set([
    `${year}-01-01`, `${year}-05-01`, `${year}-05-17`, `${year}-12-25`, `${year}-12-26`,
    ...[-3, -2, 0, 1, 39, 49, 50].map((n) => addDaysIso(easter, n)),
  ]);
  holidayCache.set(year, set);
  return set;
}

export function isNonWorkday(iso: string): boolean {
  const weekday = new Date(`${iso}T00:00:00Z`).getUTCDay();
  return weekday === 0 || weekday === 6 || norwegianHolidays(Number(iso.slice(0, 4))).has(iso);
}

export function nextWorkday(iso: string): string {
  let date = iso;
  while (isNonWorkday(date)) date = addDaysIso(date, 1);
  return date;
}

export function upcomingWorkdays(fromIso: string, count: number): string[] {
  const days: string[] = [];
  for (let date = nextWorkday(fromIso); days.length < count; date = nextWorkday(addDaysIso(date, 1))) days.push(date);
  return days;
}

export const RENTAL_DAYS = 5;

// Pickup never lands on a weekend or holiday; the shift to the next workday is free of charge.
export function pickupDateFor(deliveryDate: string, extraDays = 0): { date: string; moved: boolean } {
  const nominal = addDaysIso(deliveryDate, RENTAL_DAYS + extraDays);
  const date = nextWorkday(nominal);
  return { date, moved: date !== nominal };
}
